import { type, deepCopy } from 'es-sharp'

// 递归assign合并
function deepAssign(parent, child){
	for(var k in child){
		if(type(child[key]) == "object"){
			if(type(parent[k]) != "object"){
				parent[k] = {}
			}

			deepAssign(parent[k], child[k])
		}else{
			parent[k] = child[k]
		}
	}

	return parent
}

// 普通assign合并
function assign(parent, child){
	return Object.assign(parent, child)
}

// 数组合并
function concat(parent, child){
	return [...parent, ...child]
}

var strategy = {
	globalCache: assign,
	globalEnum: deepAssign,
	menuConfig: deepAssign,
	routes: concat,
	axios: deepAssign,
	icon: deepAssign,
	wx: deepAssign,
}

export default function(parent, ...childs) {
	return childs.reduce((acc, config) => {
		Object.keys(config).forEach(k => {
			var value = config[k],
				merge = strategy[k]

			if(merge){
				acc[k] = merge(parent[k], value)
			}else{
				acc[k] = value
			}
		})

		return acc
	}, deepCopy(parent))
}